/** The four day states the server sends. The client renders them and never derives one (A2). */
export const AVAILABILITY_STATUSES = {
  AVAILABLE: "available",
  LIMITED: "limited",
  FULLY_BOOKED: "fully_booked",
  NOT_AVAILABLE: "not_available"
}

/** Legend order, matching the design left to right. */
export const LEGEND_STATUSES = [
  { status: AVAILABILITY_STATUSES.AVAILABLE, labelKey: "availability.legend_available", labelDefault: "Available" },
  { status: AVAILABILITY_STATUSES.FULLY_BOOKED, labelKey: "availability.legend_fully_booked", labelDefault: "Fully booked" },
  { status: AVAILABILITY_STATUSES.LIMITED, labelKey: "availability.legend_limited", labelDefault: "Limited availability" },
  { status: AVAILABILITY_STATUSES.NOT_AVAILABLE, labelKey: "availability.legend_not_available", labelDefault: "Not available" }
]

/** Reason types from the contract (§2). Blackout-ish ones render as a solid scope pill. */
export const REASON_TYPES = {
  CREW_SHARED: "crew_shared",
  RESOURCE_SHARED: "resource_shared",
  BLACKOUT: "blackout",
  CREW_OFF: "crew_off",
  FULLY_BOOKED: "fully_booked"
}

/** How many start times the collapsed cell lists before "+N more". */
export const VISIBLE_SLOT_COUNT = 3

export const LISTING_TYPES = { TICKETED: "ticketed" }

export const DATE_KEY_FORMAT = "YYYY-MM-DD"
export const MONTH_LABEL_FORMAT = "MMMM YYYY"
export const SLOT_VALUE_FORMAT = "HH:mm"
export const SLOT_DISPLAY_FORMAT = "hh:mm A"

/** The day panel's chrome, matching the booking calendar's own day panel. */
export const DRAWER_WIDTH = 600
export const DRAWER_DATE_FORMAT = "ddd, MMMM D, YYYY"

/**
 * The status pill on the day panel's listing card.
 *
 * Only two statuses carry an icon in the design — the two that are a plain statement of fact.
 * `limited` and `not_available` are explained by the reason chips beside them, so an icon there
 * would be a second warning for the same thing.
 */
export const STATUS_CHIPS = {
  [AVAILABILITY_STATUSES.AVAILABLE]: {
    icon: "CheckCircle",
    iconColor: "var(--color-success)",
    labelKey: "availability.legend_available",
    labelDefault: "Available"
  },
  [AVAILABILITY_STATUSES.FULLY_BOOKED]: {
    icon: "Calendar",
    labelKey: "availability.legend_fully_booked",
    labelDefault: "Fully booked"
  },
  [AVAILABILITY_STATUSES.LIMITED]: { labelKey: "availability.legend_limited", labelDefault: "Limited availability" },
  [AVAILABILITY_STATUSES.NOT_AVAILABLE]: { labelKey: "availability.legend_not_available", labelDefault: "Not available" }
}

/** The heading above a conflict's card in the day panel — one per conflict reason type. */
export const CONFLICT_HEADINGS = {
  [REASON_TYPES.CREW_SHARED]: { key: "availability.crew_assigned_elsewhere", fallback: "Crew is assigned to another listing" },
  [REASON_TYPES.RESOURCE_SHARED]: {
    key: "availability.resource_assigned_elsewhere",
    fallback: "Resource is assigned to another listing"
  }
}

export const HOUR_MINUTE_FORMAT = "hh:mm A"
